module.exports = __webpack_public_path__ + "static/media/ELEMENTOS_BACK SECCION1.939a3ecb.png";